import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Events from './pages/Events';
import EventForm from './pages/EventForm';
import EventDetail from './pages/EventDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyPin from './pages/VerifyPin';
import Dashboard from './pages/Dashboard';
import ValidateTicket from './pages/ValidateTicket';
import EventReport from './pages/EventReport';
import Reports from './pages/Reports';
import About from './pages/About';
import Team from './pages/Team';
import Feedback from './pages/Feedback';
import ArtistSubmission from './pages/ArtistSubmission';
import PublicBooking from './pages/PublicBooking';
import ManageBooking from './pages/ManageBooking';
import BookingError from './pages/BookingError';
import CookieConsent from './components/CookieConsent';
import Privacy from './pages/Privacy';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-secondary-100 via-primary-200 to-warm-200 flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/new" element={<EventForm />} />
              <Route path="/events/edit/:uuid" element={<EventForm />} />
              <Route path="/events/:uuid" element={<EventDetail />} />
              <Route path="/events/:uuid/report" element={<EventReport />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-pin" element={<VerifyPin />} />
              <Route path="/validate-ticket/:ticketUuid" element={<ValidateTicket />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/artist-submission" element={<ArtistSubmission />} />
              <Route path="/artist-voting" element={<Navigate to="/dashboard?context=artist-voting" replace />} />
              <Route path="/book-tickets/:eventUuid" element={<PublicBooking />} />
              <Route path="/manage-booking" element={<ManageBooking />} />
              <Route path="/manage-booking/:reference" element={<ManageBooking />} />
              <Route path="/booking-error" element={<BookingError />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
